import styles from "@styles/containers/flows/FoldersList.module.scss";

import { useNavigate } from "react-router-dom";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export default function FlowFoldersList({ folders = [] }) {
  const navigate = useNavigate();

  return (
    <div className={styles.foldersList}>
      <p className={styles.label}>Suas pastas ({folders.length})</p>

      <div className={styles.folders}>
        {folders.map((folder) => (
          <div
            className={styles.folder}
            onClick={() => navigate(`/fluxos/pasta/${folder.id}`)}
          >
            <div className="d-flex align-center">
              <i className="fas fa-folder" />
              <p>{folder.name}</p>
            </div>
            {/* <div className={styles.flowsQuantity}>{folder.quantity || 0}</div> */}
          </div>
        ))}
        <div
          className={css({ folder: true, archived: true })}
          onClick={() => navigate(`/fluxos/arquivados`)}
        >
          <div className="d-flex align-center">
            <i className="far fa-box-archive" />
            <p>Arquivados</p>
          </div>
          {/* <div classNames={styles.flowsQuantity}>{0}</div> */}
        </div>
      </div>
    </div>
  );
}
